import { css } from '@fable/theme'
import { StatsHeader } from './components'
import { useStatsTheme } from './theme/ctx'
import { AnimatePresence, motion } from 'framer-motion'
import { StatsProfileSections } from './StatsProfileSections'

export const StatsProfile = () => {
  const [theme, currentTheme] = useStatsTheme((s) => [s.theme, s.currentTheme])

  return (
    <div
      className={css`
        width: 100%;
        position: relative;
      `}
    >
      <AnimatePresence>
        <motion.div
          layout
          key={currentTheme}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className={css`
            display: block;
            width: 100%;
            height: 100%;
            background-color: ${theme.colors.bg};
            border-radius: 24px 24px 0 0;
            position: absolute;
            top: 0;
            left: 0;
            will-change: opacity, transform;
          `}
        >
          <img
            className={css`
              display: block;
              width: 100%;
              position: absolute;
              top: 0;
              left: 0;
            `}
            src={theme.colors.bgGradient}
            alt={theme.id}
          />
        </motion.div>
      </AnimatePresence>
      <StatsHeader />
      <StatsProfileSections />
    </div>
  )
}
